import { MAX_DURATION_YEARS } from './filter-matchers';

export function formatDurationYears(value: number): string {
  if (value >= MAX_DURATION_YEARS) return 'Lifetime';
  return `${value} ${value === 1 ? 'Year' : 'Years'}`;
}

export function formatBenefitDurationLabel(min: number, max: number): string {
  if (max >= MAX_DURATION_YEARS) {
    return min >= MAX_DURATION_YEARS ? 'Lifetime' : `${formatDurationYears(min)} - Lifetime`;
  }
  if (min === max) return formatDurationYears(min);
  return `${min} - ${max} Years`;
}

export function formatMinimumInflationLabel(minimumPercent: number): string {
  return minimumPercent <= 0 ? 'Any' : `${minimumPercent}% or higher`;
}
